// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3CJ6l","footer":"ReportModalFilter_footer__1Ub4U"};